import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Environments } from '../models/environments.type';

export type EnvAreas  = "organization" | "surveys" | "alerts";

export interface EnvironmentDeltaResponse {
  organizationId: string;
  source: string;
  target: string;
  organization: { hasDelta: boolean; sections: DeltaSection[] };
  surveys: SurveyDelta[];
  alerts: AlertDelta[];
}

export interface DeltaSection {
  section: string;
  changes: DeltaChange[];
}

export interface SurveyDelta {
  surveyId: string;
  status: 'compared' | 'onlyInSource' | 'onlyInTarget';
  hasDelta: boolean;
  sections: DeltaSection[];
}

export interface AlertDelta {
  alertId: string;
  status: 'compared' | 'onlyInSource' | 'onlyInTarget';
  hasDelta: boolean;
  sections: DeltaSection[];
}

export interface DeltaChange {
  op: 'add' | 'remove' | 'modify';
  key: string;
  path: string | null;
  from: string;
  to: string;
}

export interface EnvironmentDeltaFullResponse {
	source: Environments;
	target: Environments;
	areas: EnvAreas[];
	summary: {
		organizationsAnalysed: number;
		organizationsWithDelta: number;
		organizationsSkippedObsolete: number;
		organizationsFailed: number;
	};
	organizations: EnvDeltaOrganizationModel[];
}

export interface EnvDeltaOrganizationModel {
  organizationId: string;
  organizationName: string;
  status: string;
  hasDelta: boolean;
  areas: EnvAreasDetailModel[];
  error?: string | null;
}

export interface EnvAreasDetailModel {
  areaKey: EnvAreas;
  hasDelta: boolean;
  itemsCompared: number;
  itemsWithDelta: number;
  itemsOnlyInSource: number;
  itemsOnlyInTarget: number;
  changedSections: number;
  changes: number;
  added: number;
  removed: number;
  modified: number;
}

@Injectable({ providedIn: 'root' })
export class ApiEnvironmentDeltaService {
  private readonly apiBaseUrl = environment.apiBaseUrl;
  private readonly apiPath = '/envdelta';

  constructor(
    private http: HttpClient) {}

  getEnvironmentsDelta(organizationId: string, source: Environments, target: Environments): Observable<EnvironmentDeltaResponse> {
    const params = new HttpParams()
          .set('organizationId', organizationId)
          .set('sourceEnv', source)
          .set('targetEnv', target);
        
    return this.http.get<EnvironmentDeltaResponse>(`${this.apiBaseUrl}${this.apiPath}`, {params})
  }

  getEnvironmentsDeltaFull(source: Environments, target: Environments): Observable<EnvironmentDeltaFullResponse> {
    const params = new HttpParams()
          .set('sourceEnv', source)
          .set('targetEnv', target);
        
    return this.http.get<EnvironmentDeltaFullResponse>(`${this.apiBaseUrl}${this.apiPath}/full`, {params})
  }
}